'use strict';

function fInitTabs () {
    function fOpenTab (aTargets, oTrigger) {
        aTargets[0].classList.remove('is-active');
        aTargets[1].classList.remove('is-active');
        aTargets[2].classList.add('is-active');
        oTrigger.classList.add('is-active');
    }

    function fGetTargets (sId) {
        const oTarget = document.getElementById(sId);
        const oParent = oTarget.closest('.js-tabs');
        const oCurrentTrigger = oParent.querySelector('.js-tabs-open.is-active');
        const oCurrentContent = oParent.querySelector('.js-tabs-target.is-active');

        return [oCurrentTrigger, oCurrentContent, oTarget];
    }

    function fHashHandler () {
        const sHash = window.location.hash.substr(1);   

        if (!sHash) return;

        const oTrigger = document.querySelector(`[data-tabs-id="${sHash}"]`);

        fOpenTab(fGetTargets(sHash), oTrigger);
    }

    function fClickHandler (oTrigger) {
        const sId = oTrigger.getAttribute('data-tabs-id');
        const aTargets = fGetTargets(sId);
                
        fOpenTab(aTargets, oTrigger);

		aTargets[2].id = '';
        window.location.hash = `#${sId}`;
        aTargets[2].id = sId;
    }

    window.addEventListener('click', function (event) {
        if (event.target.matches('.js-tabs-open') || event.target.closest('.js-tabs-open')) {
            fClickHandler(event.target);
        }
    });
    
    fHashHandler();
}